module.exports = __webpack_public_path__ + "img/t1-gray.4290995b.png";